import { canRead, canWrite } from '../access/rbacAccess'

export const CHARGES = {
  LIST: 'ejecuta.charges'
}

export const canViewCharges = () => canRead(CHARGES.LIST)

export const canManageCharges = () => canWrite(CHARGES.LIST)
